import React from "react";
import PageData from "../../PageData/PageData";
import { getAxios } from "../../../../helper/AxiosHelper";
import { ActionButton } from "../../GeneralUI";

import { useQuery } from "react-query";
const PermissionGroup = () => {

  const permissionGroupColumns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <ActionButton row={row} pageTitle="permissionGroup" hasPermission allPerm />
      ),
    },
  ];
  async function getField() {
    const url = `/admin/permissiongroup`;
    try {
      const response = await getAxios(url);
      const fetchedList = response.data;
      return fetchedList.permission_group;
    } catch (error) {
      console.log(error);
    }
  }
  const { data, error, isLoading } = useQuery("PermissionGroupList", getField);
  if (isLoading) {
    return <div>Loading......</div>;
  }
  if (error) {
    return <div>Error:{error.message}</div>;
  }

  return (
    <>
      <PageData
        columns={permissionGroupColumns}
        tableData={data}
        title="Permissiongroup"
      />
    </>
  );
};

export default PermissionGroup;
